<template>
  <q-dialog v-model="show">
    <div class="confirm-dialog" data-testid="confirm-dialog">
      <c-page-section squares>
        <q-card data-testid="confirm-dialog-card" class="full-width dialog-shadow">
          <q-card-section class="heading-section">
            <div class="heading">
              {{ title }}
              <q-icon name="close" class="close-icon" @click="closeDialog" />
            </div>
            <slot></slot>
          </q-card-section>
          <q-separator />
          <q-card-actions class="dialog-action margin-top">
            <c-dialog-form-btns
              :negative-label="cancelBtnLabel"
              :positive-label="confirmBtnLabel"
              :loading="loading"
              positive-data-testid="delete-confirmation"
              negative-data-testid="delete-cancel"
              @action:negative="closeDialog"
              @action:positive="confirmDialog"
            ></c-dialog-form-btns>
          </q-card-actions>
        </q-card>
      </c-page-section>
    </div>
  </q-dialog>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import CPageSection from '@/components/_common/PageSection.vue';
import CDialogFormBtns from '@/components/_common/DialogFormBtns.vue';
import { ConfirmDialogParams } from '@/components/_common/confirmDialog/ConfigDialogParams';

/*****************************************************************************
 * SETUP
 ****************************************************************************/

const { t } = useI18n();
const title = ref('');
const defaultCancelBtnLabel = t('cancelBtn');
const defaultConfirmBtnLabel = t('submitBtn');
const cancelBtnLabel = ref(defaultConfirmBtnLabel);
const confirmBtnLabel = ref(defaultConfirmBtnLabel);
const show = ref(false);
const loading = ref(false);
let confirmAction: () => void;

const showDialog = (params: ConfirmDialogParams) => {
  if (params) {
    title.value = params.title;
    if (params.confirmAction) confirmAction = params.confirmAction;
    cancelBtnLabel.value = params.cancelBtnLabel ? params.cancelBtnLabel : defaultCancelBtnLabel;
    confirmBtnLabel.value = params.confirmBtnLabel ? params.confirmBtnLabel : defaultConfirmBtnLabel;
  }
  show.value = true;
};

const confirmDialog = async () => confirmAction();

const toggleLoading = () => {
  loading.value = !loading.value;
};

const closeDialog = () => {
  show.value = false;
};
/*****************************************************************************
 * EXPOSE
 ****************************************************************************/

defineExpose({
  toggleLoading,
  showDialog,
  closeDialog,
});
</script>

<style lang="scss" scoped>
@import 'styles/app.variables';

.heading-section {
  @media screen and (max-width: $bp600) {
    padding-right: 35px;
  }
}

.confirm-dialog {
  width: 550px;
}
</style>
